import { Button, Loader, MediaOverlay, Text } from "@wix/design-system";
import { Link, StatusAlertFilled } from "@wix/wix-ui-icons-common";
import React, { useContext } from "react";
import { RicosContext } from "./../../ricos-context/RicosContext.js";
import { getHost, getUrlForDisplay } from "./../../plugin-link-preview/viewer/utils.js";
import { linkPreviewConverter } from "../link-preview-converter.js";
import classes from "../statics/styles/link-preview-scss.js";
import { LinkPreviewViewer } from "../viewer/link-preview-viewer.js";
const LinkPreview = ({ node, editor }) => {
  const ricosNode = React.useMemo(() => linkPreviewConverter.fromPm.convert(node.toJSON()), [node]);
  const { loading, error, link } = node.attrs;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, loading && /* @__PURE__ */ React.createElement(LinkPreviewLoading, null), error && /* @__PURE__ */ React.createElement(LinkPreviewError, { editor, link }), !loading && !error && /* @__PURE__ */ React.createElement(LinkPreviewViewer, { node: ricosNode }));
};
const LinkPreviewLoading = () => {
  const linkPreviewStyles = classes;
  const { loadingContainer } = linkPreviewStyles;
  return /* @__PURE__ */ React.createElement("div", { className: loadingContainer }, /* @__PURE__ */ React.createElement(Loader, { size: "small" }));
};
const LinkPreviewError = ({ editor, link }) => {
  const { t } = useContext(RicosContext);
  const showAsALink = () => {
    const url = link?.url;
    if (!url) {
      return;
    }
    const { state } = editor;
    const { selection } = state;
    const from = selection.from;
    editor.chain().focus().setMeta("allowTextReplace", true).insertContent(url + " ").setTextSelection({ from, to: from + url.length + 1 }).run();
  };
  return /* @__PURE__ */ React.createElement(
    MediaOverlay,
    {
      skin: "dark",
      media: /* @__PURE__ */ React.createElement("div", { className: classes.linkPreviewContainer }, /* @__PURE__ */ React.createElement("figure", { className: classes.linkPreview }, /* @__PURE__ */ React.createElement("div", { className: classes.linkPreviewPlaceholder }), /* @__PURE__ */ React.createElement("section", { className: classes.linkPreviewInfo }, /* @__PURE__ */ React.createElement("div", { className: classes.linkPreviewUrl }, getUrlForDisplay(getHost(link?.url) || link?.url || "")))))
    },
    /* @__PURE__ */ React.createElement(MediaOverlay.Content, { visible: "always" }, /* @__PURE__ */ React.createElement("div", { className: classes.overlay }, /* @__PURE__ */ React.createElement("div", { className: classes.errorContainer }, /* @__PURE__ */ React.createElement("div", { className: classes.errorInfo }, /* @__PURE__ */ React.createElement("div", { className: classes.errorIcon }, /* @__PURE__ */ React.createElement(StatusAlertFilled, { color: "white" })), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(Text, { light: true, weight: "bold" }, t("LinkPreview_Error_Title")), /* @__PURE__ */ React.createElement("br", null), /* @__PURE__ */ React.createElement(Text, { light: true }, t("LinkPreview_Error_Subtitle")))), /* @__PURE__ */ React.createElement(Button, { prefixIcon: /* @__PURE__ */ React.createElement(Link, null), priority: "secondary", onClick: showAsALink }, t("LinkPreview_Error_Button")))))
  );
};
export {
  LinkPreview
};
//# sourceMappingURL=link-preview.js.map
